/* global axios */
// API do módulo Gestão (custom/app/controllers/api/v1/accounts/neuxs/auditoria
// e minhas_avaliacoes_controller.rb). A Auditoria responde 404 para quem não
// foi marcado no Super Admin.

export const createGestaoApi = accountId => {
  const url = path => `/api/v1/accounts/${accountId}/neuxs${path}`;
  return {
    avaliacoes: params => axios.get(url('/auditoria/avaliacoes'), { params }),
    avaliacao: id => axios.get(url(`/auditoria/avaliacoes/${id}`)),
    ajusta: (id, dados) =>
      axios.patch(url(`/auditoria/avaliacoes/${id}/ajuste`), dados),
    refaz: id => axios.post(url(`/auditoria/avaliacoes/${id}/refaz`)),
    retencao: dias =>
      axios.get(url('/auditoria/retencao'), { params: { dias } }),
    custos: () => axios.get(url('/auditoria/custos')),
    configuracao: () => axios.get(url('/auditoria/configuracao')),
    salvaConfiguracao: dados =>
      axios.put(url('/auditoria/configuracao'), dados),
    relatorios: () => axios.get(url('/auditoria/relatorios')),
    relatorio: id => axios.get(url(`/auditoria/relatorios/${id}`)),
    geraRelatorio: (dias, comprar = false) =>
      axios.post(url('/auditoria/relatorios'), { dias, comprar }),
    pdfDoRelatorio: id =>
      axios.get(url(`/auditoria/relatorios/${id}/pdf`), {
        responseType: 'blob',
      }),
    enviaRelatorio: (id, dados) =>
      axios.post(url(`/auditoria/relatorios/${id}/envio`), dados),
    monitoramento: params => axios.get(url('/monitoramento'), { params }),
    aoVivo: params => axios.get(url('/monitoramento/ao_vivo'), { params }),
    minhas: pagina =>
      axios.get(url('/minhas_avaliacoes'), { params: { pagina } }),
    minha: id => axios.get(url(`/minhas_avaliacoes/${id}`)),
  };
};

export const PERIODOS = [7, 30, 90];

// "4:05" a partir de segundos (até 59:59), "1h05" acima; sem valor (ou
// negativo, de relógio fora de ordem), um traço.
export const duracao = segundos => {
  if (segundos === null || segundos === undefined || segundos < 0) return '—';
  const minutos = Math.floor(segundos / 60);
  if (minutos < 60)
    return `${minutos}:${String(segundos % 60).padStart(2, '0')}`;
  return `${Math.floor(minutos / 60)}h${String(minutos % 60).padStart(2, '0')}`;
};

export const nota = valor =>
  valor === null || valor === undefined
    ? '—'
    : Number(valor).toLocaleString('pt-BR', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });

export const reais = valor =>
  Number(valor || 0).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

export const quando = iso =>
  new Date(iso).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
